import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createVNode("svg", {
  id: "ehATimdLKYg1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 483.2 399.8",
  "shape-rendering": "geometricPrecision",
  "text-rendering": "geometricPrecision"
}, [
  /*#__PURE__*/_createVNode("defs", null, [
    /*#__PURE__*/_createVNode("linearGradient", {
      id: "ehATimdLKYg7-fill",
      x1: "201.0389",
      y1: "365.2",
      x2: "254.2851",
      y2: "365.2",
      spreadMethod: "pad",
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(0 0)"
    }, [
      /*#__PURE__*/_createVNode("stop", {
        id: "ehATimdLKYg7-fill-0",
        offset: "0%",
        "stop-color": "#003c6a"
      }),
      /*#__PURE__*/_createVNode("stop", {
        id: "ehATimdLKYg7-fill-1",
        offset: "62%",
        "stop-color": "#006290"
      }),
      /*#__PURE__*/_createVNode("stop", {
        id: "ehATimdLKYg7-fill-2",
        offset: "100%",
        "stop-color": "#0075a3"
      })
    ]),
    /*#__PURE__*/_createVNode("linearGradient", {
      id: "ehATimdLKYg8-fill",
      x1: "107.6361",
      y1: "245.0881",
      x2: "401.6805",
      y2: "442.9668",
      spreadMethod: "pad",
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(0 0)"
    }, [
      /*#__PURE__*/_createVNode("stop", {
        id: "ehATimdLKYg8-fill-0",
        offset: "0%",
        "stop-color": "#004969"
      }),
      /*#__PURE__*/_createVNode("stop", {
        id: "ehATimdLKYg8-fill-1",
        offset: "100%",
        "stop-color": "#0075a3"
      })
    ]),
    /*#__PURE__*/_createVNode("linearGradient", {
      id: "ehATimdLKYg41-fill",
      x1: "327.3842",
      y1: "201.9",
      x2: "402.9159",
      y2: "201.9",
      spreadMethod: "pad",
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(0 0)"
    }, [
      /*#__PURE__*/_createVNode("stop", {
        id: "ehATimdLKYg41-fill-0",
        offset: "0%",
        "stop-color": "#0073bf"
      }),
      /*#__PURE__*/_createVNode("stop", {
        id: "ehATimdLKYg41-fill-1",
        offset: "100%",
        "stop-color": "#b9edff"
      })
    ]),
    /*#__PURE__*/_createVNode("linearGradient", {
      id: "ehATimdLKYg42-fill",
      x1: "337.0696",
      y1: "207.5",
      x2: "416.0111",
      y2: "207.5",
      spreadMethod: "pad",
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(0 0)"
    }, [
      /*#__PURE__*/_createVNode("stop", {
        id: "ehATimdLKYg42-fill-0",
        offset: "0%",
        "stop-color": "#0097f9"
      }),
      /*#__PURE__*/_createVNode("stop", {
        id: "ehATimdLKYg42-fill-1",
        offset: "100%",
        "stop-color": "#17d3ff"
      })
    ]),
    /*#__PURE__*/_createVNode("linearGradient", {
      id: "ehATimdLKYg43-fill",
      x1: "344.2995",
      y1: "207.5845",
      x2: "409.6005",
      y2: "207.5845",
      spreadMethod: "pad",
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(0 0)"
    }, [
      /*#__PURE__*/_createVNode("stop", {
        id: "ehATimdLKYg43-fill-0",
        offset: "0%",
        "stop-color": "#0073bf"
      }),
      /*#__PURE__*/_createVNode("stop", {
        id: "ehATimdLKYg43-fill-1",
        offset: "100%",
        "stop-color": "#b9edff"
      })
    ]),
    /*#__PURE__*/_createVNode("linearGradient", {
      id: "ehATimdLKYg44-fill",
      x1: "390.517942",
      y1: "211.9501",
      x2: "427.654742",
      y2: "211.9501",
      spreadMethod: "pad",
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(0 0)"
    }, [
      /*#__PURE__*/_createVNode("stop", {
        id: "ehATimdLKYg44-fill-0",
        offset: "0%",
        "stop-color": "#0073bf"
      }),
      /*#__PURE__*/_createVNode("stop", {
        id: "ehATimdLKYg44-fill-1",
        offset: "100%",
        "stop-color": "#b9edff"
      })
    ]),
    /*#__PURE__*/_createVNode("linearGradient", {
      id: "ehATimdLKYg45-fill",
      x1: "394.945258",
      y1: "214.55",
      x2: "432.124858",
      y2: "214.55",
      spreadMethod: "pad",
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(0 0)"
    }, [
      /*#__PURE__*/_createVNode("stop", {
        id: "ehATimdLKYg45-fill-0",
        offset: "0%",
        "stop-color": "#0097f9"
      }),
      /*#__PURE__*/_createVNode("stop", {
        id: "ehATimdLKYg45-fill-1",
        offset: "100%",
        "stop-color": "#17d3ff"
      })
    ]),
    /*#__PURE__*/_createVNode("linearGradient", {
      id: "ehATimdLKYg46-fill",
      x1: "324.955904",
      y1: "239.1",
      x2: "366.106904",
      y2: "239.1",
      spreadMethod: "pad",
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(0 0)"
    }, [
      /*#__PURE__*/_createVNode("stop", {
        id: "ehATimdLKYg46-fill-0",
        offset: "0%",
        "stop-color": "#0073bf"
      }),
      /*#__PURE__*/_createVNode("stop", {
        id: "ehATimdLKYg46-fill-1",
        offset: "100%",
        "stop-color": "#b9edff"
      })
    ]),
    /*#__PURE__*/_createVNode("linearGradient", {
      id: "ehATimdLKYg47-fill",
      x1: "329.204024",
      y1: "241.107154",
      x2: "369.155845",
      y2: "242.291063",
      spreadMethod: "pad",
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(0 0)"
    }, [
      /*#__PURE__*/_createVNode("stop", {
        id: "ehATimdLKYg47-fill-0",
        offset: "0%",
        "stop-color": "#0097f9"
      }),
      /*#__PURE__*/_createVNode("stop", {
        id: "ehATimdLKYg47-fill-1",
        offset: "100%",
        "stop-color": "#17d3ff"
      })
    ]),
    /*#__PURE__*/_createVNode("linearGradient", {
      id: "ehATimdLKYg48-fill",
      x1: "349.190359",
      y1: "161.4",
      x2: "391.777859",
      y2: "161.4",
      spreadMethod: "pad",
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(0 0)"
    }, [
      /*#__PURE__*/_createVNode("stop", {
        id: "ehATimdLKYg48-fill-0",
        offset: "0%",
        "stop-color": "#0073bf"
      }),
      /*#__PURE__*/_createVNode("stop", {
        id: "ehATimdLKYg48-fill-1",
        offset: "100%",
        "stop-color": "#b9edff"
      })
    ]),
    /*#__PURE__*/_createVNode("linearGradient", {
      id: "ehATimdLKYg49-fill",
      x1: "353.073953",
      y1: "162.751168",
      x2: "395.528059",
      y2: "164.14829",
      spreadMethod: "pad",
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(0 0)"
    }, [
      /*#__PURE__*/_createVNode("stop", {
        id: "ehATimdLKYg49-fill-0",
        offset: "0%",
        "stop-color": "#0097f9"
      }),
      /*#__PURE__*/_createVNode("stop", {
        id: "ehATimdLKYg49-fill-1",
        offset: "100%",
        "stop-color": "#17d3ff"
      })
    ]),
    /*#__PURE__*/_createVNode("linearGradient", {
      id: "ehATimdLKYg59-fill",
      x1: "365.6455",
      y1: "282.792",
      x2: "332.6462",
      y2: "225.6356",
      spreadMethod: "pad",
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(0 0)"
    }, [
      /*#__PURE__*/_createVNode("stop", {
        id: "ehATimdLKYg59-fill-0",
        offset: "0%",
        "stop-color": "#ff9c00"
      }),
      /*#__PURE__*/_createVNode("stop", {
        id: "ehATimdLKYg59-fill-1",
        offset: "100%",
        "stop-color": "#ffdd54"
      })
    ]),
    /*#__PURE__*/_createVNode("linearGradient", {
      id: "ehATimdLKYg60-fill",
      x1: "353.25",
      y1: "377.7716",
      x2: "353.25",
      y2: "227.245",
      spreadMethod: "pad",
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(0 0)"
    }, [
      /*#__PURE__*/_createVNode("stop", {
        id: "ehATimdLKYg60-fill-0",
        offset: "0%",
        "stop-color": "#ff9c00"
      }),
      /*#__PURE__*/_createVNode("stop", {
        id: "ehATimdLKYg60-fill-1",
        offset: "50.55%",
        "stop-color": "#ffb300"
      }),
      /*#__PURE__*/_createVNode("stop", {
        id: "ehATimdLKYg60-fill-2",
        offset: "100%",
        "stop-color": "#ffc600"
      })
    ]),
    /*#__PURE__*/_createVNode("linearGradient", {
      id: "ehATimdLKYg62-fill",
      x1: "371.107545",
      y1: "277.782911",
      x2: "328.909011",
      y2: "281.487969",
      spreadMethod: "pad",
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(0 0)"
    }, [
      /*#__PURE__*/_createVNode("stop", {
        id: "ehATimdLKYg62-fill-0",
        offset: "0%",
        "stop-color": "#f3eefa"
      }),
      /*#__PURE__*/_createVNode("stop", {
        id: "ehATimdLKYg62-fill-1",
        offset: "100%",
        "stop-color": "#efefef"
      })
    ])
  ]),
  /*#__PURE__*/_createVNode("g", null, [
    /*#__PURE__*/_createVNode("g", null, [
      /*#__PURE__*/_createVNode("g", null, [
        /*#__PURE__*/_createVNode("g", null, [
          /*#__PURE__*/_createVNode("g", {
            id: "ehATimdLKYg6_to",
            transform: "translate(233.450016,507.875547)"
          }, [
            /*#__PURE__*/_createVNode("g", { transform: "translate(-236.50001,-341.5625)" }, [
              /*#__PURE__*/_createVNode("path", {
                d: "M0,333.6v9.1c0,2.9,3.4,5.7,10.1,7.4L202,396.5c18.3,4.4,40.9,4.4,59.2,0l201.7-49.4c6.6-1.6,10-4.4,10.1-7.2v0-9.3l-473,3Z",
                fill: "url(#ehATimdLKYg7-fill)"
              }),
              /*#__PURE__*/_createVNode("path", {
                d: "M10.1,339.1L202,377.5c18.3,3.7,40.9,3.7,59.2,0l201.7-40.8c13.5-2.7,13.5-9.5,0-12.2L271,286.1c-18.3-3.7-40.9-3.7-59.2,0L10.1,326.9c-13.5,2.8-13.5,9.5,0,12.2v0Z",
                fill: "url(#ehATimdLKYg8-fill)"
              })
            ])
          ]),
          /*#__PURE__*/_createVNode("g", {
            id: "ehATimdLKYg9_to",
            transform: "translate(247.249985,-179.503491)"
          }, [
            /*#__PURE__*/_createVNode("g", { transform: "translate(-253.149994,-186.149998)" }, [
              /*#__PURE__*/_createVNode("path", {
                d: "M190,31.7h126.3c13.5,0,24.4,10.9,24.4,24.4v260.1c0,13.5-10.9,24.4-24.4,24.4h-126.3c-13.5,0-24.4-10.9-24.4-24.4v-260.2c.1-13.4,11-24.3,24.4-24.3Z",
                fill: "#4d4d4d",
                stroke: "#263238",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }),
              /*#__PURE__*/_createVNode("path", { d: "M191.4,33.4h116.5c12.3,0,22.3,10,22.3,22.3v259.5c0,12.3-10,22.3-22.3,22.3h-116.5c-12.3,0-22.3-10-22.3-22.3v-259.5c.1-12.3,10-22.3,22.3-22.3Z" }),
              /*#__PURE__*/_createVNode("path", {
                d: "M306.9,35.9h-30.6c.1.4.2.7.2,1.1v1.8c0,2.5-2.1,4.6-4.6,4.6h-43.9c-2.6,0-4.6-2.1-4.6-4.6v-1.8c0-.4.1-.8.2-1.1h-31.1c-11.5,0-20.8,9.3-20.8,20.8v258c0,11.5,9.3,20.8,20.8,20.8h114.4c11.5,0,20.8-9.3,20.8-20.8v-258c0-11.5-9.4-20.8-20.8-20.8v0Z",
                fill: "#263238",
                stroke: "#263238",
                "stroke-width": "0.25",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }),
              /*#__PURE__*/_createVNode("path", {
                d: "M306.9,35.9h-30.6c.1.4.2.7.2,1.1v1.8c0,2.6-2.1,4.6-4.6,4.6h-43.9c-2.6,0-4.6-2.1-4.6-4.6v-1.8c0-.4.1-.8.2-1.1h-31.1c-11.5,0-20.8,9.3-20.8,20.8h156c0-11.5-9.4-20.8-20.8-20.8v0Z",
                fill: "#9e2016"
              }),
              /*#__PURE__*/_createVNode("path", {
                d: "M260.1,40.7h-20.9c-1.2,0-2.1-1-2.1-2.2v0c0-1.2,1-2.1,2.1-2.1h20.9c1.2,0,2.1,1,2.1,2.1v0c.1,1.2-.9,2.2-2.1,2.2v0Z",
                fill: "#263238",
                stroke: "#263238",
                "stroke-width": "0.25",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }),
              /*#__PURE__*/_createVNode("line", {
                x1: "204.7",
                y1: "252.7",
                x2: "296.3",
                y2: "252.7",
                fill: "none",
                stroke: "#fff",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }),
              /*#__PURE__*/_createVNode("line", {
                x1: "204.7",
                y1: "264.7",
                x2: "296.3",
                y2: "264.7",
                fill: "none",
                stroke: "#fff",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }),
              /*#__PURE__*/_createVNode("line", {
                x1: "204.7",
                y1: "276.8",
                x2: "296.3",
                y2: "276.8",
                fill: "none",
                stroke: "#fff",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }),
              /*#__PURE__*/_createVNode("path", {
                d: "M213.1,140.7c-14.2,20.6-9,48.9,11.6,63.1s48.9,9,63.1-11.6s9-48.9-11.6-63.1c-7.6-5.2-16.6-8-25.8-8-2.8,0-5.6.3-8.3.8",
                fill: "none",
                stroke: "#fff",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }),
              /*#__PURE__*/_createVNode("g", null, [
                /*#__PURE__*/_createVNode("g", {
                  id: "ehATimdLKYg20_ts",
                  transform: "translate(250.5,166.5) scale(1.367273,1.320642)"
                }, [
                  /*#__PURE__*/_createVNode("circle", {
                    r: "38.5",
                    transform: "translate(0,0)",
                    fill: "#9e2016"
                  })
                ])
              ]),
              /*#__PURE__*/_createVNode("g", {
                id: "ehATimdLKYg21_ts",
                transform: "translate(250.25,166.850006) scale(0.373293,0.330232)"
              }, [
                /*#__PURE__*/_createVNode("g", { transform: "translate(-250.25,-166.850006)" }, [
                  /*#__PURE__*/_createVNode("path", {
                    d: "M233.4,183.6c11.2-11.2,22.5-22.3,33.7-33.5",
                    fill: "none",
                    stroke: "#263238",
                    "stroke-width": "6",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }),
                  /*#__PURE__*/_createVNode("path", {
                    d: "M233.4,150.1c11.2,11.2,22.5,22.3,33.7,33.5",
                    fill: "none",
                    stroke: "#263238",
                    "stroke-width": "6",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  })
                ])
              ])
            ])
          ]),
          /*#__PURE__*/_createVNode("g", {
            id: "ehATimdLKYg24_to",
            transform: "translate(9.344881,-125.349999)"
          }, [
            /*#__PURE__*/_createVNode("g", { transform: "translate(-223.954769,-125.849998)" }, [
              /*#__PURE__*/_createVNode("line", {
                x1: "67.3",
                y1: "145.5",
                x2: "73.9",
                y2: "151.5",
                fill: "none",
                stroke: "#263238",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }),
              /*#__PURE__*/_createVNode("line", {
                x1: "73.5",
                y1: "145.2",
                x2: "67.6",
                y2: "151.8",
                fill: "none",
                stroke: "#263238",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }),
              /*#__PURE__*/_createVNode("line", {
                x1: "370.1",
                y1: "69.3",
                x2: "376.3",
                y2: "75.7",
                fill: "none",
                stroke: "#263238",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }),
              /*#__PURE__*/_createVNode("line", {
                x1: "376.4",
                y1: "69.4",
                x2: "370.1",
                y2: "75.6",
                fill: "none",
                stroke: "#263238",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }),
              /*#__PURE__*/_createVNode("line", {
                x1: "243.9",
                y1: "0.9",
                x2: "250.6",
                y2: "6.8",
                fill: "none",
                stroke: "#263238",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }),
              /*#__PURE__*/_createVNode("line", {
                x1: "250.1",
                y1: "0.5",
                x2: "244.3",
                y2: "7.2",
                fill: "none",
                stroke: "#263238",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }),
              /*#__PURE__*/_createVNode("line", {
                x1: "97.8",
                y1: "245",
                x2: "104.6",
                y2: "250.7",
                fill: "none",
                stroke: "#263238",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }),
              /*#__PURE__*/_createVNode("line", {
                x1: "104.1",
                y1: "244.5",
                x2: "98.4",
                y2: "251.2",
                fill: "none",
                stroke: "#263238",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }),
              /*#__PURE__*/_createVNode("path", {
                d: "M369.3,36.1c0,4.1-3.3,7.3-7.3,7.3s-7.3-3.3-7.4-7.3s3.3-7.3,7.3-7.4v0c4.1.1,7.4,3.4,7.4,7.4Z",
                fill: "none",
                stroke: "#263238",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }),
              /*#__PURE__*/_createVNode("g", null, [
                /*#__PURE__*/_createVNode("circle", {
                  r: "7.3",
                  transform: "translate(52.6 205.5)",
                  fill: "none",
                  stroke: "#263238",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                })
              ]),
              /*#__PURE__*/_createVNode("path", {
                d: "M402.6,111.1c.1.9-.6,1.7-1.5,1.8s-1.7-.6-1.8-1.5c0-.1,0-.2,0-.3.1-.9.9-1.6,1.8-1.5.8,0,1.4.7,1.5,1.5Z",
                fill: "none",
                stroke: "#263238",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }),
              /*#__PURE__*/_createVNode("path", {
                d: "M148.3,87.1c0,.9-.7,1.7-1.7,1.7s-1.7-.7-1.7-1.7.7-1.7,1.7-1.7v0c.9.1,1.7.8,1.7,1.7Z",
                fill: "none",
                stroke: "#263238",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }),
              /*#__PURE__*/_createVNode("path", {
                d: "M482.7,124.5c-1.5,1.3-3,2.7-4.3,4.2",
                fill: "none",
                stroke: "#fff",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              })
            ])
          ]),
          /*#__PURE__*/_createVNode("g", {
            id: "ehATimdLKYg39_to",
            transform: "translate(552.070844,220.737501)"
          }, [
            /*#__PURE__*/_createVNode("g", { transform: "translate(-378.540375,-202.139191)" }, [
              /*#__PURE__*/_createVNode("g", null, [
                /*#__PURE__*/_createVNode("path", {
                  d: "M366.2,151.4c-20.9,12.5-38.2,45.2-38.8,73.1s15.9,40.4,36.7,27.9c6.2-3.7,12.1-9.2,17.3-15.9-2.6,2.5-5.3,4.6-8.1,6.2-15.7,9.1-28.2-.3-28-20.9s13-44.7,28.7-53.7c15.7-9.1,28.2.3,28,20.9c0,.1,0,.2,0,.4.5-3.4.8-6.8.9-10.1.6-27.9-15.9-40.4-36.7-27.9v0Z",
                  fill: "url(#ehATimdLKYg41-fill)"
                }),
                /*#__PURE__*/_createVNode("path", {
                  d: "M415.9,186.9c-.7-27.4-18.9-40.4-40.7-29s-38.9,42.8-38.2,70.2s18.9,40.4,40.7,29c21.8-11.3,38.9-42.8,38.2-70.2v0Zm-42.8,55.9c-15.7,9.1-28.2-.3-28-20.9s13-44.7,28.7-53.7c15.7-9.1,28.2.3,28,20.9s-13,44.6-28.7,53.7v0Z",
                  fill: "url(#ehATimdLKYg42-fill)"
                }),
                /*#__PURE__*/_createVNode("path", {
                  d: "M377.1,165c-7.5,4.2-14.3,11.4-19.9,20c4.7-7.2,10.5-13.3,16.8-16.9c15.7-9.1,28.2.3,28,20.9s-13,44.7-28.7,53.7c-15.7,9.1-28.2-.3-28-20.9.1-8.3,2.2-17.1,5.7-25.3-4.2,9.5-6.7,19.9-6.7,29.6-.1,23.5,14.5,34.3,32.5,24.1s32.7-37.6,32.8-61.2-14.5-34.2-32.5-24v0Z",
                  fill: "url(#ehATimdLKYg43-fill)"
                }),
                /*#__PURE__*/_createVNode("path", {
                  d: "M394.3,205.3c6.2-13.9,17.9-22.2,26-18.5c8.2,3.7,9.8,17.9,3.5,31.8s-17.9,22.2-26,18.5-9.7-17.9-3.5-31.8Z",
                  fill: "url(#ehATimdLKYg44-fill)"
                }),
                /*#__PURE__*/_createVNode("path", {
                  d: "M398.8,207.9c6.2-13.9,17.9-22.2,26-18.5s9.8,17.9,3.5,31.8-17.9,22.2-26,18.5c-8.2-3.7-9.8-17.9-3.5-31.8Z",
                  fill: "url(#ehATimdLKYg45-fill)"
                }),
                /*#__PURE__*/_createVNode("path", {
                  d: "M328.4,231.3c6.3-13.8,19.1-21.6,28.5-17.3s12,19,5.7,32.9c-6.3,13.8-19.1,21.6-28.5,17.3s-12-19.1-5.7-32.9Z",
                  fill: "url(#ehATimdLKYg46-fill)"
                }),
                /*#__PURE__*/_createVNode("path", {
                  d: "M333.1,234.4c6.3-13.9,18.5-21.8,27.4-17.8s11,18.5,4.8,32.4c-6.3,13.9-18.5,21.8-27.4,17.8-8.9-4.1-11.1-18.6-4.8-32.4Z",
                  fill: "url(#ehATimdLKYg47-fill)"
                }),
                /*#__PURE__*/_createVNode("path", {
                  d: "M354.5,151.6c7.8-12.7,21.2-18.6,30.1-13.1c8.8,5.4,9.7,20.1,2,32.7-7.8,12.7-21.2,18.6-30.1,13.1-8.9-5.3-9.8-20-2-32.7Z",
                  fill: "url(#ehATimdLKYg48-fill)"
                }),
                /*#__PURE__*/_createVNode("path", {
                  d: "M358.7,153.9c7.7-12.7,21-18.7,29.6-13.4s9.4,19.8,1.6,32.5c-7.7,12.7-21,18.7-29.6,13.4s-9.4-19.9-1.6-32.5Z",
                  fill: "url(#ehATimdLKYg49-fill)"
                })
              ]),
              /*#__PURE__*/_createVNode("g", null, [
                /*#__PURE__*/_createVNode("path", {
                  d: "M385.4,168.8L364,176.2c-.7.2-1.2-.2-1.3-1l-.3-15.5c0-.8.5-1.6,1.2-1.8l21.4-7.4c.7-.2,1.2.2,1.3,1l.3,15.5c0,.7-.5,1.6-1.2,1.8v0Z",
                  fill: "#fdbe09"
                }),
                /*#__PURE__*/_createVNode("path", {
                  d: "M371.7,163.2c.3-.5,1-1.2,1.9-1.7.1-.1.6-.3,1.3-.5.9-.2,1.6,0,2,.2.5.2,1,.5,1.5.7l8.1,4.3v.1.7c0,.3-.1.7-.3,1.1-.2.3-.5.6-.9.7l-21.4,7.4c-.7.2-1.2-.2-1.3-1v0-.7-.1c2-2.5,4.1-5.1,6.1-7.6c1.1-1.3,2.1-2.5,3-3.6v0Z",
                  fill: "#fd9f00"
                }),
                /*#__PURE__*/_createVNode("path", {
                  d: "M368.9,168.1c1-1.2,1.9-2.4,2.9-3.6.3-.5,1-1.2,1.9-1.7.1-.1.6-.3,1.3-.5.9-.2,1.6,0,2,.2.5.2,1,.5,1.5.7c2.7,1.4,5.3,2.8,8,4.3.1-.2.1-.4.1-.6v-.7-.1l-8.1-4.3c-.5-.2-1-.5-1.5-.7s-1.1-.4-2-.2c-.7.1-1.2.4-1.3.5-.9.5-1.6,1.3-1.9,1.7-1,1.2-1.9,2.4-2.9,3.6-2,2.5-4.1,5.1-6.1,7.6v.1.7v0c0,.2,0,.3.1.5c1.9-2.5,4-5,6-7.5v0Z",
                  fill: "#fc7201"
                }),
                /*#__PURE__*/_createVNode("path", {
                  d: "M377.3,163.4c-.3.5-1,1.2-1.9,1.7-.1.1-.6.3-1.3.5-.9.2-1.6,0-2-.2-.5-.2-1-.5-1.5-.7l-8.1-4.3v-.1-.7c0-.3.1-.7.3-1.1.2-.3.5-.6.9-.7l21.4-7.4c.7-.2,1.2.2,1.3,1v0v.7.1c-2,2.5-4.1,5.1-6.1,7.6-1,1.2-2,2.4-3,3.6v0Z",
                  fill: "#fdd34f"
                }),
                /*#__PURE__*/_createVNode("path", {
                  d: "M380.2,158.5c-1,1.2-1.9,2.4-2.9,3.6-.3.5-1,1.2-1.9,1.7-.1.1-.6.3-1.3.5-.9.2-1.6,0-2-.2-.5-.2-1-.5-1.5-.7-2.7-1.4-5.3-2.8-8-4.3-.1.2-.1.4-.1.6v.7.1l8.1,4.3c.5.2,1,.5,1.5.7s1.1.4,2,.2c.7-.1,1.2-.4,1.3-.5.9-.5,1.6-1.3,1.9-1.7c1-1.2,1.9-2.4,2.9-3.6c2-2.5,4.1-5.1,6.1-7.6v-.1-.7v0c0-.2,0-.3-.1-.5-2,2.5-4,5-6,7.5v0Z",
                  fill: "#fd8301"
                })
              ]),
              /*#__PURE__*/_createVNode("path", {
                d: "M401.8,217.1l18.7-14.8c.9-.7,1.6-.3,1.4,1.3v0L419,222c-.2,1.3-.8,1.8-1.7,1.6l-5-2.4-2.3,3.4c-.3.4-.5.7-1,.9l.2-5.8l8.9-12.5c.4-.5-.1-.6-.6,0l-11,11.9-4.9-.1c-1-.1-1-.9.2-1.9v0v0Z",
                fill: "#fff"
              })
            ])
          ]),
          /*#__PURE__*/_createVNode("g", {
            id: "ehATimdLKYg57_to",
            transform: "translate(539.946194,408.459058)"
          }, [
            /*#__PURE__*/_createVNode("g", { transform: "translate(-359.290344,-271.945206)" }, [
              /*#__PURE__*/_createVNode("g", null, [
                /*#__PURE__*/_createVNode("path", {
                  d: "M314.3,252.9c0-14.8,4.6-25.5,12.1-30.6v0v0c.9-.6,1.9-1.2,2.9-1.7l10.4-6c6.8-4,15.8-3.7,25.6,2c21.5,12.4,39,45.7,39,74.4c0,15.4-5,26.3-13,31.2v0c-.4.3-12,6.8-12,6.8-6.9,4.3-16,4-26-1.7-3.9-2.3-7.7-5.2-11.3-8.7l-16.6-23.1c-6.9-13.3-11.1-28.5-11.1-42.6v0Z",
                  fill: "url(#ehATimdLKYg59-fill)"
                }),
                /*#__PURE__*/_createVNode("path", {
                  d: "M329.8,220.3c17.2-7.3,41.6,11.4,54.6,41.8c12.9,30.4,9.5,61-7.7,68.3s-41.6-11.4-54.6-41.8c-12.9-30.4-9.5-61,7.7-68.3Z",
                  fill: "url(#ehATimdLKYg60-fill)"
                })
              ]),
              /*#__PURE__*/_createVNode("g", null, [
                /*#__PURE__*/_createVNode("path", {
                  d: "M342.5,288.7c-.6-1.5-1.2-3.1-1.6-4.6-3.5-1.7-7.6-7.1-10.6-13.8-1.8-3.9-3-8-3.3-12.1-.1-1.6-.3-3.9,1-5.4.4-.5.9-.7,1.2-.9c1.2-.5,2.3-.9,3.5-1.4.4,1,1,2.1,1.6,3.3c1.8,3.2,3.9,5.5,5.7,7.1.3-.6.8-1.4,1.6-2.2c1.8-1.8,5.1-3.6,7.1-2.3.4.2,1,.8,1.3,2v0c-1.4-6.9-.6-12,2.1-12.7v0c0,0,.3-.2,1-.7.6-.4,1.5-.8,2.5-.7c5.3.4,8.2,13.4,8.9,16.7.9,3.9,1.7,9.5,1.1,16.6.4,1,1.1,2.5,1.9,4.3c2.2,5.6,9.7,24,3.3,29.6-1.6,1.4-3.7,1.6-4.9,1.6-12.8.9-23-23.4-23.4-24.4v0Z",
                  fill: "url(#ehATimdLKYg62-fill)"
                }),
                /*#__PURE__*/_createVNode("path", {
                  d: "M345.9,287.4c-.6-1.5-1.2-3.1-1.6-4.6-3.5-1.7-7.6-7.1-10.6-13.8-1.8-3.9-3-8-3.3-12.1-.2-3.5.6-5.7,2.3-6.2h.1c2.7-.7,7,2.9,10.7,9c.8-1.7,2.2-3,4-3.5c1.9-.5,4.1-.1,6,1v0c-1.4-6.9-.6-12,2.1-12.7h.1c3.6-.7,9.1,6.1,12.2,15.3c2.4,6.9,2.8,13.6,1.1,16.6.7,1.4,1.3,2.9,1.9,4.3c6.1,15.4,5.4,29.4-1.5,31.2-6.9,1.9-17.5-9.1-23.5-24.5v0Z",
                  fill: "#fff"
                })
              ])
            ])
          ]),
          /*#__PURE__*/_createVNode("g", {
            id: "ehATimdLKYg64_to",
            transform: "translate(-59.141221,282.230962)"
          }, [
            /*#__PURE__*/_createVNode("g", { transform: "translate(-145.376831,-250.476593)" }, [
              /*#__PURE__*/_createVNode("path", {
                d: "M158.9,187.8c.2.1.4.3.6.3.3.1.6,0,.9-.1.7-.3,1.4-.7,2.1-1.1c3.1-1.9,5.9-4.3,8.2-7c1.4-1.6,2.7-3.2,2.4-5.4c0-.2-.1-.5-.2-.8-.5-1.6-1.6-3.2-2.7-4.4-4.3-5-9.8-9-14.8-13.4-.9-.7-1.7-1.5-2.6-2.3-1.2-1.1-2.4-2.2-3.5-3.4-1-1.2-1.9-2.4-3.1-3.5-.8-.7-1.8-1.4-2.8-1.3-.7,0-1.4.4-1.8,1-.3-.2-.8-.2-1.1,0-.7.2-1.2.7-1.6,1.4-.2-.1-.4-.1-.7,0-.9.3-1.5,1-1.7,1.9-.3-.2-.7-.1-1,.1s-.5.5-.7.8c0-.2-.1-.3-.3-.4-.4-.1-.6.3-.7.6s-.1.5-.1.8.1.5.2.8c.6,1.7,2.5,2.5,3.8,3.6.5.4.9.9,1.5,1.2.5.3,1,.4,1.5.5c1,.2,2.1.2,3.1,0c.4-.1.8-.2,1.1-.4.6-.3,1.5-.2,2.1.3.2.2.4.4.6.6s.4.5.6.7c.9,1.2,1.8,2.4,2.6,3.6c1.1,1.6,2.3,3.2,3.4,4.8c1,1.5,1.9,2.9,2.8,4.4.3.5.5,1,.8,1.5.1.2.3.5.2.7v0c-1,1.3-2.6,2.1-3.7,3.3.3.3.6.5.9.8.4.5.3.9.3,1.5-.2,1.5-.2,3.1.4,4.5.3.7.6,1.3,1.1,1.9.4.7,1.1,1.3,1.9,1.9v0Z",
                fill: "#fdcdb1"
              }),
              /*#__PURE__*/_createVNode("path", {
                d: "M148.6,183.2c.2.2.4.3.6.3.3.1.6,0,.9-.1.7-.3,1.4-.6,2.1-1.1c3.1-1.9,5.9-4.2,8.3-6.9c1.4-1.5,2.8-3.1,2.5-5.4c0-.2-.1-.5-.2-.8-.1.9-.6,1.7-1.1,2.3-1.8,2.4-3.9,4.6-6.4,6.4-.2.2-.5.3-.8.4-.5,0-1-.4-1.3-.8-1-1.3-1.7-2.7-2.6-4s-2.2-2.5-3.7-2.9c.5,1.9.3,3.8,0,5.7-.2,1.6-.5,3.3-.4,4.9.7.8,1.4,1.5,2.1,2v0Z",
                fill: "#fdbd97"
              }),
              /*#__PURE__*/_createVNode("path", {
                d: "M158.2,187.8c.2.2.4.3.6.3.3.1.6,0,.9-.1.7-.3,1.4-.6,2.1-1.1c3.1-1.9,5.9-4.2,8.3-6.9c1.4-1.5,2.8-3.1,2.5-5.4c0-.2-.1-.5-.2-.8-.1.9-.6,1.7-1.1,2.3-1.8,2.4-3.9,4.6-6.4,6.4-.2.2-.5.3-.8.4-.5,0-1-.4-1.3-.8-1-1.3-1.7-2.7-2.6-4s-2.2-2.5-3.7-2.9c.5,1.9.3,3.8,0,5.7-.2,1.6-.5,3.3-.4,4.9.7.7,1.4,1.4,2.1,2v0Z",
                fill: "#fdbd97"
              }),
              /*#__PURE__*/_createVNode("path", {
                d: "M137.9,155.9c.5.4.9.9,1.5,1.2.5.3,1,.4,1.5.5c1,.2,2.1.2,3.1,0c.4-.1.8-.2,1.1-.4.6-.3,1.5-.2,2.1.3.2.2.4.4.6.6s.4.5.6.7c.9,1.2,1.8,2.4,2.6,3.6c1.1,1.6,2.3,3.2,3.4,4.8c1,1.5,1.9,2.9,2.8,4.4.3.5.5,1,.8,1.5.1.2.3.5.2.7.5-.5-.6-3.1-.8-3.6-.4-1.3-1-2.6-1.6-3.8-1.2-2.5-2.7-4.8-4.5-6.9-1.6-1.9-3.6-3.7-6.2-3.8-1.4,0-2.8.2-4.3-.1-1.1-.2-2.2-.7-3.2-1.2-1.4-.7-2.8-1.7-3.7-2.9c0,.3.1.5.2.8.6,1.7,2.5,2.5,3.8,3.6v0Z",
                fill: "#fdbd97"
              }),
              /*#__PURE__*/_createVNode("path", {
                d: "M147.8,190.8c0,.3,0,.7.4.9.2.1.5.1.7.1c2.7-.2,5.4-.7,7.8-1.6c2.7-.9,5.1-2.3,7-4c.9-.9,1.7-1.8,2.3-2.8.4-.6,1.4-2.5.2-2.9-4.3-1.3-8.9-2.3-13.4-3.1c0,.1-.6.5-.7.6-.3.2-.7.2-1,.4-.2.1-.4.2-.6.3-.5.2-1.1.5-1.5.8-.5.4-.8.8-1.1,1.2-.6,1-.9,2.1-.8,3.3c0,1.2.5,2.3.8,3.5.3,1,0,2.3-.1,3.3v0Z",
                fill: "#f0ece1"
              }),
              /*#__PURE__*/_createVNode("g", null, [
                /*#__PURE__*/_createVNode("path", {
                  d: "M147.8,190.9c0,.3,0,.7.4.9.2.1.5.1.7.1c2.8-.2,5.5-.7,8.1-1.5-.5-4-3.1-7.9-6.5-11.1-.5.2-1.1.5-1.5.8-.5.3-.8.8-1.1,1.2-.6,1-.9,2.1-.9,3.1c0,1.2.5,2.3.8,3.4.4.8.1,2.1,0,3.1v0Z",
                  fill: "#f0ece1"
                })
              ]),
              /*#__PURE__*/_createVNode("path", {
                d: "M117.7,340.9c.4.6.9,1.1,1.4,1.7c1.3,1.8,1.8,4,2.3,6.1.6,2.1,1.4,4.3,3,5.7c1.1.9,2.4,1.3,3.7,1.3c1.3.1,2.7-.2,4-.7.7-.3,1.5-.7,2-1.2.6-.6,1-1.3.9-2.2c0-1-.7-1.9-1.4-2.6-1.3-1.3-2.7-2.5-3.7-4-1.3-2.1-2.3-4.4-3.1-6.7-.3-.9-.5-1.7-.8-2.6-.1-.6-.3-1.1-.4-1.7c0-.2-.1-.5-.1-.7-.1-.7-.1-1.7-.4-2.3-.5-1.1-2.5-1.3-3.6-1.2-.7.1-1.4.3-1.9.7-1.7,1-2.9,2.7-3.3,4.7-.2,2.1.3,4.2,1.4,5.7v0Z",
                fill: "#f0ece1"
              }),
              /*#__PURE__*/_createVNode("g", null, [
                /*#__PURE__*/_createVNode("path", {
                  d: "M117.7,340.9c.4.6.9,1.1,1.4,1.7c1.3,1.8,1.8,4,2.3,6.1.6,2.1,1.4,4.3,3,5.7c1.1.9,2.4,1.3,3.7,1.3-1-.7-1.8-1.5-2.5-2.4-1.6-2.3-2.1-5.2-2.6-7.9-.3-1.4-.5-2.9-.9-4.3-.5-1.8-1.6-3,.2-4.5.7-.6,1.6-1,2.3-1.5.4-.3.8-.6,1.2-1c0-.2-.1-.5-.1-.7-.1-.7-.1-1.7-.4-2.3-.5-1.1-2.5-1.3-3.6-1.2-.7.1-1.4.3-1.9.7-1.7,1-2.9,2.7-3.3,4.7s.1,4.1,1.2,5.6v0Z",
                  fill: "#f0ece1"
                })
              ]),
              /*#__PURE__*/_createVNode("path", {
                d: "M136.8,327.1c.6,1.7,2.3,2.6,3.9,3.3s3.3,1.4,4.2,2.9c.3.6.4,1.3.6,1.9.5,1.8,1.3,3.7,2.8,4.8.6.5,1.3.8,2,1c.8.3,1.6.5,2.4.5.4,0,.8-.1,1.2-.2.4-.2.8-.4,1-.8.7-.8.7-2,.3-3-.3-1-1-1.9-1.6-2.7-1.2-1.6-2.5-3.2-3.3-5s-1.1-3.7-1.2-5.7c0-.2,0-.4,0-.6v-.3c0-1.1,0-2.1-.4-3.1-.1-.1-.1-.3-.2-.3s-.3,0-.4,0c-1.3.1-2.6.2-3.9.1s-2.6-.5-3.7-1.2c.2.1-.4,1.2-.5,1.4-.2.4-.5.8-.8,1.1-.8.8-1.4,1.4-1.9,2.4-.7,1.1-.9,2.4-.5,3.5v0Z",
                fill: "#f0ece1"
              }),
              /*#__PURE__*/_createVNode("g", null, [
                /*#__PURE__*/_createVNode("path", {
                  d: "M136.8,327.1c.6,1.7,2.3,2.6,3.9,3.3s3.3,1.4,4.2,2.9c.3.6.4,1.3.6,1.9.5,1.8,1.3,3.7,2.8,4.8.6.5,1.3.8,2,1c.8.3,1.6.5,2.4.5.4,0,.8-.1,1.2-.2-.6-.2-1.2-.5-1.8-.8-1.8-1-3.3-2.3-4.3-4.1-.8-1.4-1.1-3.1-1.7-4.6-.8-2.1-2.1-3.9-3.6-5.4-.4-.4-.8-.8-.7-1.3.2-.7,1.1-.7,1.7-.6c1.1.2,2.2.2,3.3,0c.7-.2,1.6-.7,2.3-1.3c0-1.1,0-2.1-.4-3.1-.1-.1-.1-.3-.2-.3s-.3,0-.4,0c-1.3.1-2.6.2-3.9.1s-2.6-.5-3.7-1.2c.2.1-.4,1.2-.5,1.4-.2.4-.5.8-.8,1.1-.8.8-1.4,1.4-1.9,2.4-.7,1.1-.9,2.4-.5,3.5v0Z",
                  fill: "#f0ece1"
                })
              ]),
              /*#__PURE__*/_createVNode("path", {
                d: "M129.5,247.8c.9,6.1,2.5,12.2,5,17.9c1.2,2.8,2.6,5.5,4.2,8.1c1.4,2.2,3.2,4.5,2.9,7.2-.5,4-2.1,7.8-2.4,11.9-.3,4.4,0,8.9.3,13.3.2,2.3.6,11.2.6,13.3c0,.1,0,.2,0,.4c0,.1.1.2.2.3.4.5.9,1.1,1.4,1.5l.1.1c1.1.9,2.5,1.5,4,1.5.9,0,3.2-.3,3.4-1.5.3-1.2.3-2.5.4-3.7.2-1.6,1.6-12.6,2.2-16.4.5-3.7,1-7.3,1.5-11c.3-2,.5-3.9.9-5.8.5-2.8,1-5.8.9-8.8-.1-2.9-.8-5.9-1.5-8.7-.4-1.4-3.3-13.9-4.5-19.8-.1-.3-.1-.6-.2-.8-.6-3.3-1.2-6.6-2.5-9.7-.2-.5-.6-1.2-1.2-1.2-.3,0-.6.2-.9.3-1.1.6-2.5,1-3.8.8s-2.4-.6-3.7-.3c-1.2.2-2.4.8-3.4,1.6-1.1.9-2.3,2.3-2.8,3.8-.4,1.2-1.1,2.6-1.3,3.8c0,.7.1,1.3.2,1.9v0Z",
                fill: "#5289a1"
              }),
              /*#__PURE__*/_createVNode("path", {
                d: "M129.5,247.8c.9,6.1,2.5,12.2,5,17.9c1.2,2.8,2.6,5.5,4.2,8.1c1.4,2.2,3.2,4.5,2.9,7.2-.5,4-2.1,7.8-2.4,11.9-.3,4.4,0,8.9.3,13.3.2,2.3.6,11.2.6,13.3c0,.1,0,.2,0,.4c0,.1.1.2.2.3.4.5.9,1.1,1.4,1.5l.1.1c.8-13.4,1.5-26.8,2.3-40.2.2-2.5.3-5.1-.3-7.5-.8-3.3-2.8-6.2-4.2-9.3-.9-2-1.6-4.4-.7-6.5.9-2.3,3.4-3.7,5.3-5.2c2.1-1.6,3.9-3.4,5-5.5-.1-.3-.1-.6-.2-.8-.6-3.3-1.2-6.6-2.5-9.7-.2-.5-.6-1.2-1.2-1.2-.3,0-.6.2-.9.3-1.1.6-2.5,1-3.8.8s-2.4-.6-3.7-.3c-1.2.2-2.4.8-3.4,1.6-1.1.9-2.3,2.3-2.8,3.8-.4,1.2-1.1,2.6-1.3,3.8-.1.7,0,1.3.1,1.9v0Z",
                fill: "#5289a1"
              }),
              /*#__PURE__*/_createVNode("path", {
                d: "M109.7,257.5c1,6.3,2.4,12.5,4.2,18.6c1.5,5.3,4.7,11.5,4.2,17.1-.5,5.4-3.1,10.4-3.2,15.9-.2,5.2.1,10.8,1.2,15.9.5,2.2,1,4.4,1.5,6.6.3,1.2.3,1.9,1.5,2.4.2.1.4.2.7.3c1.8.6,3.8.4,5.4-.5.9-.5.7-1.3,1-2.2.3-1.1,4.8-32.3,5.8-41.5.5-4.6.7-9.2.9-13.8.3-6.9.6-13.8.5-20.7-.1-5.8-.5-11.6-1.5-17.3c0,.4-1.3,1.6-1.5,1.9-.7.7-1.4,1.3-2.2,1.8-.6.4-1.4.9-2.1.9-.9-.1-1.9-.7-2.8-.9-2.3-.6-4.8-.7-7,.2-1.8.7-3.3,2-4.6,3.5-.6.7-1.6.3-2.1-.3-1.1,3.8-.6,8,.1,12.1v0Z",
                fill: "#5289a1"
              }),
              /*#__PURE__*/_createVNode("path", {
                d: "M109.7,257.5c1,6.3,2.4,12.5,4.2,18.6c1.5,5.3,4.7,11.5,4.2,17.1-.5,5.4-3.1,10.4-3.2,15.9-.2,5.2.1,10.8,1.2,15.9.5,2.2,1,4.4,1.5,6.6.3,1.2.3,1.9,1.5,2.4.2.1.4.2.7.3c0-5.1.3-10.1.8-15.2.8-8.1,2.2-16.2,2.6-24.3s-.1-16.5-3.1-24.1c-.8-2.1-1.8-4.2-2-6.4s.5-4.8,2.4-5.9c2.8-1.6,6.9-.7,10-1.6c1-.3,2-.8,2.7-1.3-.1-5.8-.5-11.6-1.5-17.3c0,.4-1.3,1.6-1.5,1.9-.7.7-1.4,1.3-2.2,1.8-.6.4-1.4.9-2.1.9-.9-.1-1.9-.7-2.8-.9-2.3-.6-4.8-.7-7,.2-1.8.7-3.3,2-4.6,3.5-.6.7-1.6.3-2.1-.3-.9,3.9-.4,8.1.3,12.2v0Z",
                fill: "#5289a1"
              }),
              /*#__PURE__*/_createVNode("path", {
                d: "M108.9,246.9c.2,1,.6,1.2,1.5,1.8c1.4.8,2.7,1.6,4.2,2.2c1.9.9,4,1.4,6,1.8c1.4.3,2.9.6,4.4.7c3,.4,6,.5,9,.2c4.5-.4,8.9-1.8,12.7-4.2c2.6-1.7,2.4-4.2,2.6-7.1.1-2,.2-3.9.3-5.9.5-10.3,2.1-41.3,2.4-46.5.3-4.7.9-9.4-.4-13.9-1-3.3-4.8-5.1-7.9-5.4-2.5-.2-5,.4-7.4,1-2.3.6-4.9,1-6.9,2.1-2.2,1.2-4.4,2.4-6.4,3.8-2.8,1.8-5,3.8-7.2,6.4-3.1,3.7-4.7,8.3-4.9,13.2c0,.6-.1,1.2-.1,1.7c0,.7.3,1.4.4,2.1c0,.4.1.8.1,1.2.2,3,0,6-.2,9-.2,3.6-.5,7.1-.8,10.7-.6,5.7-2,22.7-1.4,25.1v0Z",
                fill: "#f0ece1"
              }),
              /*#__PURE__*/_createVNode("g", null, [
                /*#__PURE__*/_createVNode("path", {
                  d: "M108.9,246.9c.2,1,.6,1.2,1.5,1.8c1.4.8,2.7,1.6,4.2,2.2c1.9.9,4,1.4,6,1.8c1.4.3,2.9.6,4.4.7.6-1.5,1-3,1.4-4.5c2.2-7.5,4.3-15.1,4.7-23c.2-3.8-.1-7.5-.5-11.3-.6-5.4-1.4-10.9-3.4-15.9-1.6-4-4-9.4-9.1-6.9-3.7,1.8-5.6,6-6.7,10.1.2,3,0,6-.2,9-.2,3.6-.5,7.1-.8,10.7-.7,5.9-2.1,22.9-1.5,25.3v0Z",
                  fill: "#f0ece1"
                })
              ]),
              /*#__PURE__*/_createVNode("path", {
                d: "M125.2,180.6c.6,1,1.4,1.7,2.2,2.4c1.2.9,2.4,1.8,3.7,2.5v0c1.3.7,2.7,1.3,4.1,1.8.9.3,1.9.5,2.9.4c1-.2,1.9-.8,2.2-1.8.1-.4.1-.9.2-1.3.4-1.3,1.9-2.1,2.8-2.9c1.1-1.1,1.9-2.4,2.3-3.9.9-3.2,0-6.5-.7-9.8-.3-1.3-.6-2.6-1.4-3.6-1-1.2-2.8-1.7-4.3-1.1-.8.3-1.4.8-1.9,1.5-.8,1-1.4,2.2-2.1,3.3-1.5,2.5-3.7,4.5-6.3,5.8-.8.4-1.7.8-2.5,1.3s-1.5,1.2-1.8,2.1c-.2,1.1,0,2.4.6,3.3v0Z",
                fill: "#fdcdb1"
              }),
              /*#__PURE__*/_createVNode("path", {
                d: "M125.2,180.6c.6,1,1.4,1.7,2.2,2.4c1.2.9,2.4,1.8,3.7,2.5-.4-.7-.8-1.4-.9-2.2-.5-2.4,1.2-4.7,2.9-6.1c1.2-1,2.6-1.8,3.8-2.8.1-.1.2-.1.2-.2c1.1-1,2.1-2.1,2.6-3.6.6-2-.1-4.2-1.6-5.5-.2-.2-.4-.3-.7-.5-.8,1-1.4,2.2-2.1,3.3-1.5,2.5-3.7,4.5-6.3,5.8-.8.4-1.7.8-2.5,1.3s-1.5,1.2-1.8,2.1c-.3,1.3-.1,2.6.5,3.5v0Z",
                fill: "#fdbd97"
              }),
              /*#__PURE__*/_createVNode("path", {
                d: "M139.4,172.8c.2.6.6,1.1.7,1.7.2.8.1,1.6,0,2.4c0,.8,0,1.5,0,2.3c0,.7.2,1.5.5,2.1.3.5.7.8,1.1,1.2c1.7,1.6,3.5,3.2,5.6,4.1.5.2.9.4,1.4.3.2,0,.3-.1.5-.1.6-.2,1.1-.8,1.6-1.3.5-.6,1.1-1.2,1.6-1.8s.8-1,1.6-.7c.3.1.6.3.9.4.2.1.4.1.7,0c.3,0,.6-.1.8-.3s.3-.5.4-.7c.2-1.2.1-2.4.1-3.6c0-.4,0-.8.2-1.1.3-.8.9-1.1,1.5-1.6.7-.6,1.2-1.6,1.6-2.3.9-1.6,1.7-3.3,2.3-5.1.7-2.1,1.2-4.3.5-6.4-.1-.3-.3-.7-.7-.7-.3,0-.5.2-.7.4-.5.3-.8.2-1.3,0-.5-.3-1.1-.5-1.7-.6-1.8-.3-3.7.2-5.4.8-.9.3-1.8.7-2.6,1.2-.7.4-1.5.8-2.2,1.2-.9.6-1.7,1.2-2.7,1.5-1.3.4-2.8.2-4,.8-.9.4-1.6,1.2-2,2.1-.7,1-.7,2.5-.3,3.8v0Z",
                fill: "#fdcdb1"
              }),
              /*#__PURE__*/_createVNode("path", {
                d: "M139.4,172.8c.2.6.6,1.1.7,1.7.2.8.1,1.6,0,2.4c0,.8,0,1.5,0,2.3c0,.7.2,1.5.5,2.1.3.5.7.8,1.1,1.2c1.7,1.6,3.5,3.2,5.6,4.1.5.2.9.4,1.4.3.2,0,.3-.1.5-.1-.3-.9-.5-1.8-.6-2.8-.3-1.9-.1-3.8.8-5.5.7-1.3,1.8-2.3,2.8-3.4s2.1-2.3,2.8-3.7c.7-1.3,1.3-3.4.5-4.7-.9-1.5-2.2-2.5-3.8-3.2-.3-.1-.7-.3-1-.4-.7.4-1.5.8-2.2,1.2-.9.6-1.7,1.2-2.7,1.5-1.3.4-2.8.2-4,.8-.9.4-1.6,1.2-2,2.1-.8,1.3-.8,2.8-.4,4.1v0Z",
                fill: "#fdbd97"
              }),
              /*#__PURE__*/_createVNode("path", {
                d: "M136.2,170.8c.3.6.6,1.2,1.1,1.6s1.2.6,1.8.2.7-1.2.8-1.9c.2-1.4.8-3,2-3.4.8-.3,1.9,0,2.5.6.7.7,1,1.6,1.1,2.5.1.6,0,1.3.1,1.9.1.5.3.9.5,1.3.1.1.1.3.2.3.1.1.3.1.5,0c1-.2,1.8-1,2.8-1.3.9-.3,1.8-.2,2.7-.6.8-.4,1.6-1,1.9-1.9.2-.5.1-1.1.3-1.6.2-.7.7-1.3,1.3-1.7.3-.2.6-.3.9-.2c1.1.1,1.8,1,2.6,1.7s1.7,1.2,2.7,1.4c2.6.3,2.8-3.3,2.7-5.2-.1-2.2-.7-4.2-1.7-6.1-1.4-2.7-3.7-5.1-6.1-6.7-3.3-2.2-7.3-3-11.1-1.9v0c-3.4,1-6.3,3.4-8.2,6.4-1.4,2.1-2,4.2-2.3,6.7-.4,2.8-.1,5.5.9,7.9v0Z",
                fill: "#864e6d"
              }),
              /*#__PURE__*/_createVNode("path", {
                d: "M136.2,170.8c.3.6.6,1.2,1.1,1.6s1.2.6,1.8.2.7-1.2.8-1.9c.2-1.4.8-3,2-3.4.8-.3,1.9,0,2.5.6.7.7,1,1.6,1.1,2.5.1.6,0,1.3.1,1.9.1.5.3.9.5,1.3.1.1.1.3.2.3.1.1.3.1.5,0c1-.2,1.8-1,2.8-1.3.9-.3,1.8-.2,2.7-.6.8-.4,1.6-1,1.9-1.9.2-.5.1-1.1.3-1.6.2-.7.7-1.3,1.3-1.7-.1,0-.1,0-.1-.1-.5-.2-.9-.4-1.4-.7-1.8-1-3.4-2.3-4.7-4-.7-.9-1.4-1.9-1.9-2.9-1.5-2.9-2.1-6.2-1.8-9.4-3.4,1-6.3,3.4-8.2,6.4-1.4,2.1-2,4.2-2.3,6.7-.5,2.9-.2,5.6.8,8v0Z",
                fill: "#864e6d"
              }),
              /*#__PURE__*/_createVNode("path", {
                d: "M115.3,216.7c1.6,4.3,3.5,8.3,5.5,12.4.6,1.2,1.2,2.4,2,3.4.7.9,1.6,1.4,2.7,1.7.9.3,1.9.3,2.8.4.8,0,1.6.1,2.4.1c4.8.1,9.6-.2,14.4-.9c2.4-.4,4.7-.8,7.1-1.4c1.2-.3,5.5-1.6,6.6-1.7.5-.1.9-.2,1.4-.3c2.1-.3,4.2-.3,6.2-.5c1.2-.1,2.4-.3,3.5-.7.9-.3,1.9-.7,2.8-1.1.4-.2.8-.4,1.2-.7.2-.1.3-.3.4-.5.3-.3.5-.7.7-1.1.6-.8,1.4-1.3,2.1-2c.2-.2.4-.5.6-.7.1-.3.1-.7-.1-.9-.1-.1-.2-.2-.3-.3-.4-.3-.5-.8-.8-1.2-.5-.7-1.4-1.1-2.2-.9-.4.1-.7.3-1.1.3s-.7-.3-1.1-.4c-1.1-.4-2.4.3-3.4,1.1-.3.2-.5.4-.7.7-.1.2-.1.4-.2.6-.1.3-.4.4-.7.5-1.3.4-2.6-.2-4-.1-1.2.1-2.1.8-3,1.5-1.2,1-2.5,1.6-4.1,1.8-1.9.2-3.8.2-5.7.1-4.2-.2-8.4-.9-12.5-1.6-1.4-.3-2.9-.5-4.3-.7-1-.2-2,0-2.7-.9s-.9-2.2-1.2-3.3-.6-2.2-.9-3.3c-.1-.5-.3-1.1-.5-1.6-.6-1.9-1.8-3.4-3.6-4.2-1.6-.7-3.5-.7-5.3-.3-1,.2-1.9.5-2.8,1-.8.5-1.5,1.4-1.8,2.4-.2.9.2,2.1.6,3.3v0Z",
                fill: "#fdcdb1"
              }),
              /*#__PURE__*/_createVNode("path", {
                d: "M115.3,216.7c1.6,4.3,3.5,8.3,5.5,12.4.6,1.2,1.2,2.4,2,3.4.7.9,1.6,1.4,2.7,1.7.9.3,1.9.3,2.8.4.8,0,1.6.1,2.4.1c4.8.1,9.6-.2,14.4-.9c2.4-.4,4.7-.8,7.1-1.4c1.2-.3,5.5-1.6,6.6-1.7.5-.1.9-.2,1.4-.3c2.1-.3,4.2-.3,6.2-.5c1.2-.1,2.4-.3,3.5-.7.9-.3,1.9-.7,2.8-1.1.4-.2.8-.4,1.2-.7-3.9.7-7.8,1.2-11.8,1.6-2.9.3-5.7.4-8.5,1-3.3.6-6.4,1.8-9.7,2.5-4.5.9-9.1.9-13.6,0-1.7-.3-3.3-.8-4.7-1.8-2.8-2.1-3.9-5.8-4.3-9.2c0-.4-.1-.9.1-1.3.3-.6.9-.8,1.5-1c1.6-.5,3.1-1.2,4.5-2.2.5-.4.9-.7,1.2-1-.1-.5-.3-1.1-.5-1.6-.6-1.9-1.8-3.4-3.6-4.2-1.6-.7-3.5-.7-5.3-.3-1,.2-1.9.5-2.8,1-.8.5-1.5,1.4-1.8,2.4-.1,1,.3,2.2.7,3.4v0Z",
                fill: "#fdbd97"
              }),
              /*#__PURE__*/_createVNode("g", null, [
                /*#__PURE__*/_createVNode("path", {
                  d: "M176.1,226.2l-12-2c-.2,0-.3-.1-.3-.3l-.1-.5.4.1l4.6-4.7c.2-.2.7-.4,1.1-.3l10.8,1.8l1,.2.3-.3.1.5v0c0,.1,0,.2-.1.3l-4.7,4.8c-.1.1-.4.3-.6.3-.2.1-.4.1-.5.1v0Z",
                  fill: "#cab8b8"
                }),
                /*#__PURE__*/_createVNode("g", null, [
                  /*#__PURE__*/_createVNode("path", {
                    d: "M172.7,225.3c0,0,.1,0,0,0c.1-.1.1-.1.2-.1l1.2.2c.1,0,.2.1.2.2v.1c0,0,0,0,0,.1v0v0c0,0-.1.1-.2.1l-1.2-.2c-.1,0-.2-.1-.2-.2v-.2v0v0Z",
                    fill: "#4d4d4d"
                  }),
                  /*#__PURE__*/_createVNode("g", null, [
                    /*#__PURE__*/_createVNode("path", {
                      d: "M174.1,225.5l-1.2-.2h-.1l-.1.1h.1l1.2.2v0c.1,0,.1.1.1.1v0v.1c0,0,0,0,0,.1l.1-.1v0c0,0,0,0,0-.1v-.1v0c.1-.1,0-.1-.1-.1v0v0Z",
                      fill: "#e6dedb"
                    }),
                    /*#__PURE__*/_createVNode("path", {
                      d: "M174.3,225.6l-.1.1v0v.1c0,0,0,0,0,.1l.1-.1v0c0,0,0,0,0-.1v-.1v0v0Z",
                      fill: "#fdf5f0"
                    }),
                    /*#__PURE__*/_createVNode("path", {
                      d: "M174.1,225.5l-.1.1c.1,0,.1.1.1.1l.1-.1c.1-.1,0-.1-.1-.1v0Z",
                      fill: "#f0e8e4"
                    }),
                    /*#__PURE__*/_createVNode("path", {
                      d: "M174,225.6l-1.2-.2h-.1v0c0,0,0,0,0,.1v.1c0,.1.1.1.2.1l1.2.2h.1v0c0,0,0,0,0-.1v-.1c0-.1-.1-.1-.2-.1v0Z",
                      fill: "#b19f9f"
                    })
                  ])
                ]),
                /*#__PURE__*/_createVNode("path", {
                  d: "M176.5,226.2l-.1-.7l1.1-2.7l2.9-2.6l1,.2.3-.3.1.5v0c0,.1,0,.2-.1.3l-4.7,4.8c0,.3-.2.4-.5.5v0Z",
                  fill: "#f0e8e4"
                }),
                /*#__PURE__*/_createVNode("path", { d: "M169.6,218l12,2c.2,0,.3.1.3.2v0c0,.1,0,.2-.1.3l-4.7,4.8c-.2.2-.7.4-1.1.3l-12-2c-.2,0-.3-.1-.3-.3v0c0-.1,0-.2.1-.3l4.7-4.8c.2-.2.7-.3,1.1-.2v0Z" }),
                /*#__PURE__*/_createVNode("path", {
                  d: "M166.2,221.3h-.1c-.1,0-.1,0-.1-.1v0c0,0,0,0,0-.1l1-1.1.1-.1c.1-.1.2-.1.4-.1h.1c.1,0,.1,0,.1.1v0v0c0,0,0,0,0,.1l-1.1,1.1v0c-.1.2-.3.2-.4.2v0Z",
                  fill: "#cab8b8"
                }),
                /*#__PURE__*/_createVNode("path", {
                  d: "M177.3,223.9v0c-.1,0-.1,0-.1-.1v0c0,0,0,0,0-.1l1.4-1.4c.1-.1.2-.1.2-.1v0c0,0,.1,0,.1.1v0c0,0,0,0,0,.1l-1.4,1.4c0,0-.1.1-.2.1v0Z",
                  fill: "#cab8b8"
                }),
                /*#__PURE__*/_createVNode("path", {
                  d: "M165,223.2v0l4.6-4.7c.1-.1.3-.2.4-.2l9.3,1.6.5.1c.1,0,.2.1.1.2c0,0,0,.1-.1.1l-4.5,4.6c-.1.1-.3.2-.4.2l-9.8-1.6c-.1-.1-.2-.1-.1-.3v0Z",
                  fill: "#600d4a"
                }),
                /*#__PURE__*/_createVNode("path", {
                  d: "M174.9,225.1l-.4-.1-7.5-1.2h-.3l-1.6-.3c-.1,0-.2-.2-.1-.3l4.5-4.6c.1-.1.3-.2.4-.1l1.6.3h.3l7.5,1.2.5.1c.1,0,.2.2.1.3l-4.5,4.6c-.2,0-.4.1-.5.1v0Z",
                  fill: "#a1e2fd"
                }),
                /*#__PURE__*/_createVNode("g", null, [
                  /*#__PURE__*/_createVNode("path", {
                    d: "M177.4,223.9v0c-.1,0-.1,0-.1-.1v-.1c0,0,.1.1.1.2v0v0c.1-.1.2-.1.2-.1v0l1.4-1.4c0,0,0,0,0-.1v.1v0c0,0,0,0,0,.1l-1.4,1.4v0c0-.1-.1,0-.2,0v0v0Z",
                    fill: "#cab8b8"
                  }),
                  /*#__PURE__*/_createVNode("path", {
                    d: "M177.7,223.8v0v0l1.4-1.5c0,0,0,0,0-.1v.1v0c0,0,0,0,0,.1l-1.4,1.4v0v0Z",
                    fill: "#fdf5f0"
                  }),
                  /*#__PURE__*/_createVNode("path", {
                    d: "M177.5,223.9v0c.1-.1.2-.1.2-.2v.1c-.1,0-.2.1-.2.1v0Z",
                    fill: "#e6dedb"
                  }),
                  /*#__PURE__*/_createVNode("path", {
                    d: "M177.4,223.8v0c-.1,0-.1,0-.1-.1v0c0,0,0,0,0-.1l1.4-1.4c.1-.1.2-.1.2-.1v0c0,0,.1,0,.1.1v0c0,0,0,0,0,.1l-1.4,1.4c0,.1-.1.1-.2.1v0Z",
                    fill: "#f0e8e4"
                  }),
                  /*#__PURE__*/_createVNode("g", null, [
                    /*#__PURE__*/_createVNode("g", null, [
                      /*#__PURE__*/_createVNode("path", {
                        d: "M178.8,222.3v0c0-.1.1-.1.1-.1s0,0,0,.1c0,0,0,0-.1,0v0Z",
                        fill: "#cab8b8"
                      }),
                      /*#__PURE__*/_createVNode("path", {
                        d: "M178.8,222.3h.1v0v0c0-.1-.1-.1-.1,0v0v0v0Z",
                        fill: "#fdf5f0"
                      })
                    ]),
                    /*#__PURE__*/_createVNode("g", null, [
                      /*#__PURE__*/_createVNode("path", {
                        d: "M178.7,222.5c0,0-.1-.1,0,0c0-.1.1-.1.1-.1s0,0,0,.1c0-.1-.1,0-.1,0v0Z",
                        fill: "#cab8b8"
                      }),
                      /*#__PURE__*/_createVNode("path", {
                        d: "M178.7,222.4h.1v0v0h-.1v0v0v0Z",
                        fill: "#fdf5f0"
                      })
                    ]),
                    /*#__PURE__*/_createVNode("g", null, [
                      /*#__PURE__*/_createVNode("path", {
                        d: "M178.6,222.6c-.1,0-.1,0,0,0c0-.1.1-.1.1-.1s0,0,0,.1c-.1,0-.1,0-.1,0Z",
                        fill: "#cab8b8"
                      }),
                      /*#__PURE__*/_createVNode("path", {
                        d: "M178.5,222.6h.1v0v0c0-.1,0-.1-.1,0v0v0v0Z",
                        fill: "#fdf5f0"
                      })
                    ]),
                    /*#__PURE__*/_createVNode("g", null, [
                      /*#__PURE__*/_createVNode("path", {
                        d: "M178.4,222.7v0c0-.1.1-.1.1-.1s0,0,0,.1c0,0,0,0-.1,0v0Z",
                        fill: "#cab8b8"
                      }),
                      /*#__PURE__*/_createVNode("path", {
                        d: "M178.4,222.7h.1v0v0c0-.1-.1-.1-.1,0v0v0v0Z",
                        fill: "#fdf5f0"
                      })
                    ]),
                    /*#__PURE__*/_createVNode("g", null, [
                      /*#__PURE__*/_createVNode("path", {
                        d: "M178.3,222.9c-.1,0-.1-.1,0,0c0-.1.1-.1.1-.1s0,0,0,.1-.1,0-.1,0v0Z",
                        fill: "#cab8b8"
                      }),
                      /*#__PURE__*/_createVNode("path", {
                        d: "M178.3,222.8h.1v0v0c0,0-.1,0-.1,0s-.1,0,0,0c0,.1,0,0,0,0v0Z",
                        fill: "#fdf5f0"
                      })
                    ]),
                    /*#__PURE__*/_createVNode("g", null, [
                      /*#__PURE__*/_createVNode("path", {
                        d: "M178.1,223v0c0-.1.1-.1.1-.1s0,0,0,.1c0,0,0,0-.1,0Z",
                        fill: "#cab8b8"
                      }),
                      /*#__PURE__*/_createVNode("path", {
                        d: "M178.1,223h.1v0v0c0-.1,0-.1-.1,0v0v0v0Z",
                        fill: "#fdf5f0"
                      })
                    ]),
                    /*#__PURE__*/_createVNode("g", null, [
                      /*#__PURE__*/_createVNode("path", {
                        d: "M178,223.2c0-.1,0-.1,0,0c0-.1.1-.1.1-.1s0,0,0,.1-.1,0-.1,0Z",
                        fill: "#cab8b8"
                      }),
                      /*#__PURE__*/_createVNode("path", {
                        d: "M178,223.1h.1v0v0c0-.1-.1,0-.1,0v0v0v0Z",
                        fill: "#fdf5f0"
                      })
                    ]),
                    /*#__PURE__*/_createVNode("g", null, [
                      /*#__PURE__*/_createVNode("path", {
                        d: "M177.9,223.3c-.1,0-.1,0,0,0c0-.1.1-.1.1-.1s0,0,0,.1h-.1Z",
                        fill: "#cab8b8"
                      }),
                      /*#__PURE__*/_createVNode("path", {
                        d: "M177.9,223.2h.1v0v0c-.1,0-.1,0-.1,0-.1,0-.1.1,0,0-.1.1,0,.1,0,0v0Z",
                        fill: "#fdf5f0"
                      })
                    ]),
                    /*#__PURE__*/_createVNode("g", null, [
                      /*#__PURE__*/_createVNode("path", {
                        d: "M177.7,223.4v0c0-.1.1-.1.1-.1s0,0,0,.1c0,0,0,0-.1,0v0Z",
                        fill: "#cab8b8"
                      }),
                      /*#__PURE__*/_createVNode("path", {
                        d: "M177.7,223.4h.1v0v0c0-.1,0-.1-.1,0v0v0v0Z",
                        fill: "#fdf5f0"
                      })
                    ]),
                    /*#__PURE__*/_createVNode("g", null, [
                      /*#__PURE__*/_createVNode("path", {
                        d: "M177.6,223.6c0,0,0-.1,0,0c0-.1.1-.1.1-.1s0,0,0,.1-.1,0-.1,0v0Z",
                        fill: "#cab8b8"
                      }),
                      /*#__PURE__*/_createVNode("path", {
                        d: "M177.6,223.5h.1v0v0c0,0-.1,0-.1,0v0v0v0Z",
                        fill: "#fdf5f0"
                      })
                    ]),
                    /*#__PURE__*/_createVNode("g", null, [
                      /*#__PURE__*/_createVNode("path", {
                        d: "M177.5,223.7c-.1,0-.1,0,0,0c0-.1.1-.1.1-.1s0,0,0,.1h-.1Z",
                        fill: "#cab8b8"
                      }),
                      /*#__PURE__*/_createVNode("path", {
                        d: "M177.5,223.7h.1v0v0c-.1-.1-.1-.1-.1,0-.1,0-.1,0,0,0-.1,0-.1,0,0,0v0Z",
                        fill: "#fdf5f0"
                      })
                    ])
                  ]),
                  /*#__PURE__*/_createVNode("path", {
                    d: "M178.1,223.3c.2-.3.3-.6.5-.9l.2-.2c.1-.1.2-.1.2-.1v0c0,0,.1,0,.1.1v0c0,0,0,0,0,.1l-1,1Z",
                    fill: "#979797"
                  })
                ]),
                /*#__PURE__*/_createVNode("g", null, [
                  /*#__PURE__*/_createVNode("path", {
                    d: "M179.7,221.3v0c0,0,0-.1,0,0c.1-.2.3-.2.4-.2s.1,0,.1.1v0c0,0,0,0,0,.1-.2,0-.4.1-.5,0c0,0-.1,0,0,0v0Z",
                    fill: "#fff"
                  }),
                  /*#__PURE__*/_createVNode("path", { d: "M179.7,221.3v0c0,0,0-.1,0,0c.1-.1.2-.2.3-.1c0,0,.1,0,.1.1v0c0,0,0,0,0,.1-.1-.1-.3,0-.4-.1v0v0Z" }),
                  /*#__PURE__*/_createVNode("path", {
                    d: "M179.7,221.3v0c0,0,.1,0,0,0c.1-.1.2-.1.3-.1c0,0,.1,0,0,.1v0v0c0,0-.1.1-.3,0v0v0Z",
                    fill: "#8e76b7"
                  }),
                  /*#__PURE__*/_createVNode("path", {
                    d: "M179.8,221.3v0v0c.1-.1.1-.1.2-.1v0v0v0c-.1.1-.1.2-.2.1v0Z",
                    fill: "#b37dbb"
                  }),
                  /*#__PURE__*/_createVNode("path", {
                    d: "M179.8,221.3v0v0l.1-.1v0v0v0c0,.1,0,.2-.1.1v0v0Z",
                    fill: "#d883be"
                  }),
                  /*#__PURE__*/_createVNode("path", {
                    d: "M179.9,221.3v0v0v0v0v0v0c0,0,0,.1,0,0v0v0Z",
                    fill: "#fd8bc1"
                  }),
                  /*#__PURE__*/_createVNode("path", {
                    d: "M179.9,221.2v0c.1,0,.1,0,0,0c0,0,.1-.1.1,0v0v0v0c0,.1,0,.1-.1,0c.1.1,0,0,0,0v0Z",
                    fill: "#666"
                  }),
                  /*#__PURE__*/_createVNode("path", {
                    d: "M179.9,221.3v0v0c0-.1.1-.1,0,0c.1-.1.1-.1,0,0v0v0c.1,0,0,0,0,0v0v0Z",
                    fill: "#666"
                  }),
                  /*#__PURE__*/_createVNode("path", {
                    d: "M180,221.2v0v0v0v0v0v0v0v0Z",
                    fill: "#666"
                  })
                ]),
                /*#__PURE__*/_createVNode("g", null, [
                  /*#__PURE__*/_createVNode("path", {
                    d: "M180,220.8v0c0,0,0-.1.1-.1.1-.1.4-.2.6-.2.1,0,.1.1.1.1v0c0,0,0,.1-.1.1-.1.1-.4.2-.6.2c0,0-.1-.1-.1-.1Z",
                    fill: "#fff"
                  }),
                  /*#__PURE__*/_createVNode("path", { d: "M180.1,220.8v0c0,0,0-.1,0,0c.2-.2.4-.3.6-.2.1,0,.1.1.1.1v0c0,0,0,.1-.1.1-.1.1-.3.2-.5.1-.1,0-.1,0-.1-.1Z" }),
                  /*#__PURE__*/_createVNode("path", {
                    d: "M180.2,220.8v0v0c.2-.2.3-.2.4-.2s.1.1.1.1v0c0,0,0,0-.1.1s-.2.1-.4,0c0,.1,0,.1,0,0Z",
                    fill: "#8e76b7"
                  }),
                  /*#__PURE__*/_createVNode("path", {
                    d: "M180.2,220.8v0c0,0,.1,0,0,0c.1-.1.2-.2.3-.1c0,0,.1,0,.1.1v0c0,0,0,0,0,.1-.1,0-.2,0-.4-.1c0,.1,0,.1,0,0v0Z",
                    fill: "#b37dbb"
                  }),
                  /*#__PURE__*/_createVNode("path", {
                    d: "M180.3,220.9v0c0-.1,0-.1,0,0c.1-.1.2-.1.2-.1v0v0v0c0,.1-.1.1-.2.1v0Z",
                    fill: "#d883be"
                  }),
                  /*#__PURE__*/_createVNode("path", {
                    d: "M180.4,220.9v0v0c0,0,.1-.1.1,0v0v0v0c-.1,0-.1,0-.1,0v0v0Z",
                    fill: "#fd8bc1"
                  }),
                  /*#__PURE__*/_createVNode("path", {
                    d: "M180.5,220.7v0v0c.1-.1.1-.1.2-.1v0v0v0c0,.1-.1.2-.2.1v0v0Z",
                    fill: "#666"
                  }),
                  /*#__PURE__*/_createVNode("path", {
                    d: "M180.5,220.8v0c0-.1,0-.1,0,0c0-.1,0-.1,0,0c.1,0,.1,0,.1,0v0c0-.1,0-.1-.1,0v0v0Z",
                    fill: "#666"
                  }),
                  /*#__PURE__*/_createVNode("path", {
                    d: "M180.6,220.7v0v0v0v0v0v0v0v0v0Z",
                    fill: "#666"
                  })
                ]),
                /*#__PURE__*/_createVNode("g", null, [
                  /*#__PURE__*/_createVNode("path", {
                    d: "M166.4,221.3h-.1c-.1,0-.1,0-.1-.1v-.1l.1.1.1.1c0-.1,0-.1,0,0c.1-.1.3-.1.4-.2v0l1.1-1.1.1-.1v.1v0v.1l-1.1,1.1v0c-.2,0-.4.1-.5.1v0v0Z",
                    fill: "#cab8b8"
                  }),
                  /*#__PURE__*/_createVNode("path", {
                    d: "M166.8,221.2v0v0l1.1-1.2.1-.1v.1v0v.1l-1.2,1.1v0v0Z",
                    fill: "#fdf5f0"
                  }),
                  /*#__PURE__*/_createVNode("path", {
                    d: "M166.4,221.3v0c.1-.1.3-.1.3-.2v.1c0,0-.2.1-.3.1v0Z",
                    fill: "#f0e8e4"
                  }),
                  /*#__PURE__*/_createVNode("path", {
                    d: "M166.4,221.2h-.1c-.1,0-.1,0-.1-.1v0-.1l1.1-1.1c.1-.1.3-.1.4-.1h.1c.1,0,.1.1.1.1v0c0,0,0,.1-.1.1l-1.1,1.1c0,.1-.2.1-.3.1v0Z",
                    fill: "#d7cfcc"
                  }),
                  /*#__PURE__*/_createVNode("path", {
                    d: "M166.4,221.2h-.1c-.1,0-.1,0-.1-.1v0c0,0,0,0,0-.1l1-1.1.1-.1c.1-.1.2-.1.4-.1h.1c.1,0,.1,0,.1.1v0v0c0,0,0,0,0,.1l-1.1,1.1v0c-.1.1-.3.2-.4.2v0Z",
                    fill: "#fdf5f0"
                  }),
                  /*#__PURE__*/_createVNode("path", {
                    d: "M166.7,221.1c.2-.4.3-.8.5-1.1l.1-.1c.1-.1.2-.1.4-.1h.1c.1,0,.1,0,.1.1v0v0c0,0,0,0,0,.1l-1.2,1.1v0Z",
                    fill: "#cacaca"
                  })
                ])
              ]),
              /*#__PURE__*/_createVNode("path", {
                d: "M110.2,212.5c0,.5.1,1.1.4,1.5.2.3.6.5.9.7c2,1.1,4.2,2,6.5,2.4.7.1,1.4.2,2.2.2c2.3.1,4.7-.4,6.7-1.6.9-.5,1.7-1,1.9-2.1.3-1.2,0-2.3-.2-3.4-.2-1.6-.5-3.2-.8-4.8-.7-3.1-1.6-6.1-2.7-9-1-2.6-2.3-5.2-4.3-7.1-1-.9-2.2-1.7-3.5-2.2-.6-.2-1.1-.3-1.7-.4-1.7-.2-2.8,2.1-3.5,3.4-1.1,2.2-1.2,5.5-1.5,7.8-.8,4.9-.9,9.8-.4,14.6v0Z",
                fill: "#f0ece1"
              }),
              /*#__PURE__*/_createVNode("g", null, [
                /*#__PURE__*/_createVNode("path", {
                  d: "M110.2,212.5c0,.5.1,1.1.4,1.5.2.3.6.5.9.7c2,1.1,4.2,2,6.5,2.4-1.5-4.7-2.6-9.5-2.9-14.4-.2-2.5-.1-5.1.2-7.6.3-2.2.7-4.5,1.4-6.6.2-.5.4-.9.5-1.4-.6-.2-1.1-.3-1.7-.4-1.7-.2-2.8,2.1-3.5,3.4-1.1,2.2-1.2,5.5-1.5,7.8-.7,4.9-.8,9.8-.3,14.6v0Z",
                  fill: "#f0ece1"
                })
              ]),
              /*#__PURE__*/_createVNode("path", {
                d: "M167.5,222.9c1.1.1,2.1-.3,3.2-.3.7,0,1.7,0,2.1.7.3.4.3,1,0,1.4-.5.8-1.5.8-2.3.9-1,.1-1.9.1-2.9.3-1.6.3-3.1,1.3-4.6,1.7-.8.3-1.7.4-2.6.1-.8-.3-1.5-1.2-1.3-2.1.1-.4.3-.7.5-1c1.3-1.7,3.6-2.3,5.6-2.1.8.1,1.5.3,2.3.4v0Z",
                fill: "#fdbd97"
              }),
              /*#__PURE__*/_createVNode("path", {
                d: "M143.3,145.3c1.2-.4,2.7,1.1,2.1,2.3-.1.3-.3.5-.5.8-.1.2-.2.5-.3.8c0,.1,0,.1,0,.2s.1.2.2.2c.1.1.3.2.5.3.2,0,.4.1.5.2.1.2.1.4.1.6c0,.3-.1.5-.2.8s-.4.4-.6.4-.4-.1-.5,0c-.2.1-.2.3-.3.4-.3.5-1.1.7-1.6.4-.2.4-.6.7-1.1.8s-1,0-1.4-.3c0,.4-.5.8-.9.8-.4.1-.9,0-1.3-.2-.7-.2-1.3-.5-1.8-1s-.8-1.2-.7-1.9c.1-.6.6-1.1,1.1-1.4.2-.1.5-.3.7-.1.3-.4.7-.8,1.1-1.1s1-.5,1.5-.3c.3-.8,1.2-1.3,2.1-1.1.2-.6.6-1.4,1.3-1.6v0Z",
                fill: "#fdbd97"
              })
            ])
          ])
        ]),
        /*#__PURE__*/_createVNode("g", {
          id: "ehATimdLKYg180_to",
          transform: "translate(1,116.063893)"
        }, [
          /*#__PURE__*/_createVNode("g", { transform: "translate(0,0)" }, [
            /*#__PURE__*/_createVNode("path", {
              d: "M280.8,313.9h-98.3c-1.4,0-2.7-.5-3.7-1.3-1-.9-1.5-2-1.5-3.3v-8.9c0-2.6,2.3-4.6,5.2-4.6h98.3c2.8,0,5.2,2.1,5.2,4.6v0v8.9c0,2.5-2.3,4.6-5.2,4.6v0Z",
              fill: "#b28c66"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M189.2,309.3v-8.9c0-2.6,2.4-4.6,5.3-4.6h-11c-2.9,0-5.2,2-5.3,4.6v8.9c0,2.6,2.4,4.6,5.3,4.6h11c-2.9,0-5.3-2-5.3-4.6v0Z",
              opacity: "0.1"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M279.8,313.9h-94.7v47.6c0,2.6,2.4,4.7,5.3,4.7h84.1c2.9,0,5.2-2.1,5.3-4.7v-47.6v0Z",
              fill: "#b28c66"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M279.8,324v-10.1h-94.7v47.6c0,2.6,2.4,4.7,5.3,4.7h8.8c-2.9,0-5.2-2.1-5.3-4.7v-37.5h85.9v0Z",
              opacity: "0.1"
            }),
            /*#__PURE__*/_createVNode("g", { transform: "translate(44 7)" }, [
              /*#__PURE__*/_createVNode("path", {
                d: "M172.2,299.1c-.9,0-1.6-.6-1.6-1.4v-2.7c0-.8.7-1.4,1.6-1.4s1.6.6,1.6,1.4v2.7c0,.4-.2.7-.5,1-.3.2-.7.4-1.1.4Z",
                fill: "#4a5058"
              }),
              /*#__PURE__*/_createVNode("path", {
                d: "M169.2,301.8c0-.8.7-1.4,1.6-1.5h3c.9,0,1.6.7,1.6,1.5s-.7,1.4-1.6,1.5h-3c-.4,0-.8-.2-1.1-.4-.4-.3-.5-.7-.5-1.1v0Z",
                fill: "#a07e5c"
              }),
              /*#__PURE__*/_createVNode("path", {
                d: "M209.3,299.1c-.9,0-1.6-.6-1.6-1.4v-2.7c0-.8.7-1.4,1.6-1.4s1.6.6,1.6,1.4v2.7c0,.8-.7,1.4-1.6,1.4Z",
                fill: "#4a5058"
              }),
              /*#__PURE__*/_createVNode("path", {
                d: "M206.3,301.8c0-.8.7-1.4,1.6-1.5h3c.9,0,1.6.7,1.6,1.5s-.7,1.4-1.6,1.5h-3c-1,0-1.7-.7-1.6-1.5Z",
                fill: "#a07e5c"
              }),
              /*#__PURE__*/_createVNode("g", { transform: "translate(20.002 4.999)" }, [
                /*#__PURE__*/_createVNode("ellipse", {
                  rx: "3.9",
                  ry: "3.5",
                  transform: "translate(170.4 296.3)",
                  fill: "#495058"
                }),
                /*#__PURE__*/_createVNode("ellipse", {
                  rx: "3.5",
                  ry: "3.1",
                  transform: "translate(170.4 296.3)",
                  fill: "none",
                  stroke: "#4a5058"
                })
              ]),
              /*#__PURE__*/_createVNode("g", { transform: "translate(-24591.8-6989.02)" }, [
                /*#__PURE__*/_createVNode("g", {
                  id: "ehATimdLKYg194_to",
                  transform: "translate(24767.106445,7289.75)"
                }, [
                  /*#__PURE__*/_createVNode("g", {
                    id: "ehATimdLKYg194",
                    transform: "translate(-24767.106445,-7289.75)"
                  }, [
                    /*#__PURE__*/_createVNode("path", {
                      d: "M24767.2,7291.6c-.5,0-1-.4-1-.9c0-.2.1-.3.2-.5v0v0l.8-1.8.8,1.8v0v0c.1.1.2.3.2.5-.1.5-.5.9-1,.9Z",
                      fill: "#255dc4"
                    }),
                    /*#__PURE__*/_createVNode("path", {
                      d: "M24767.2,7291.3c.3,0,.6-.2.6-.5c0-.1-.1-.2-.1-.3v-.1-.1l-.4-.9-.4,1v.1c-.1.1-.1.2-.1.3-.2.2,0,.5.4.5m0,.7c-.7,0-1.4-.5-1.4-1.2c0-.2.1-.5.2-.7l1.1-2.6l1.1,2.6c.1.2.2.4.2.7.1.6-.5,1.2-1.2,1.2Z",
                      fill: "#255dc5"
                    })
                  ])
                ]),
                /*#__PURE__*/_createVNode("g", {
                  id: "ehATimdLKYg197_to",
                  transform: "translate(24767.106445,7289.75)"
                }, [
                  /*#__PURE__*/_createVNode("g", {
                    id: "ehATimdLKYg197",
                    transform: "translate(-24767.106445,-7289.75)"
                  }, [
                    /*#__PURE__*/_createVNode("path", {
                      d: "M24767.2,7291.6c-.5,0-1-.4-1-.9c0-.2.1-.3.2-.5v0v0l.8-1.8.8,1.8v0v0c.1.1.2.3.2.5-.1.5-.5.9-1,.9Z",
                      fill: "#255dc4"
                    }),
                    /*#__PURE__*/_createVNode("path", {
                      d: "M24767.2,7291.3c.3,0,.6-.2.6-.5c0-.1-.1-.2-.1-.3v-.1-.1l-.4-.9-.4,1v.1c-.1.1-.1.2-.1.3-.2.2,0,.5.4.5m0,.7c-.7,0-1.4-.5-1.4-1.2c0-.2.1-.5.2-.7l1.1-2.6l1.1,2.6c.1.2.2.4.2.7.1.6-.5,1.2-1.2,1.2Z",
                      fill: "#255dc5"
                    })
                  ])
                ]),
                /*#__PURE__*/_createVNode("g", {
                  id: "ehATimdLKYg200_to",
                  transform: "translate(24767.106445,7289.75)"
                }, [
                  /*#__PURE__*/_createVNode("g", {
                    id: "ehATimdLKYg200",
                    transform: "translate(-24767.106445,-7289.75)"
                  }, [
                    /*#__PURE__*/_createVNode("path", {
                      d: "M24767.2,7291.6c-.5,0-1-.4-1-.9c0-.2.1-.3.2-.5v0v0l.8-1.8.8,1.8v0v0c.1.1.2.3.2.5-.1.5-.5.9-1,.9Z",
                      fill: "#255dc4"
                    }),
                    /*#__PURE__*/_createVNode("path", {
                      d: "M24767.2,7291.3c.3,0,.6-.2.6-.5c0-.1-.1-.2-.1-.3v-.1-.1l-.4-.9-.4,1v.1c-.1.1-.1.2-.1.3-.2.2,0,.5.4.5m0,.7c-.7,0-1.4-.5-1.4-1.2c0-.2.1-.5.2-.7l1.1-2.6l1.1,2.6c.1.2.2.4.2.7.1.6-.5,1.2-1.2,1.2Z",
                      fill: "#255dc5"
                    })
                  ])
                ]),
                /*#__PURE__*/_createVNode("g", {
                  id: "ehATimdLKYg203_to",
                  transform: "translate(24767.106445,7289.75)"
                }, [
                  /*#__PURE__*/_createVNode("g", {
                    id: "ehATimdLKYg203",
                    transform: "translate(-24767.106445,-7289.75)"
                  }, [
                    /*#__PURE__*/_createVNode("path", {
                      d: "M24767.2,7291.6c-.5,0-1-.4-1-.9c0-.2.1-.3.2-.5v0v0l.8-1.8.8,1.8v0v0c.1.1.2.3.2.5-.1.5-.5.9-1,.9Z",
                      fill: "#255dc4"
                    }),
                    /*#__PURE__*/_createVNode("path", {
                      d: "M24767.2,7291.3c.3,0,.6-.2.6-.5c0-.1-.1-.2-.1-.3v-.1-.1l-.4-.9-.4,1v.1c-.1.1-.1.2-.1.3-.2.2,0,.5.4.5m0,.7c-.7,0-1.4-.5-1.4-1.2c0-.2.1-.5.2-.7l1.1-2.6l1.1,2.6c.1.2.2.4.2.7.1.6-.5,1.2-1.2,1.2Z",
                      fill: "#255dc5"
                    })
                  ])
                ]),
                /*#__PURE__*/_createVNode("g", null, [
                  /*#__PURE__*/_createVNode("path", {
                    d: "M24767.2,7291.6c-.5,0-1-.4-1-.9c0-.2.1-.3.2-.5v0v0l.8-1.8.8,1.8v0v0c.1.1.2.3.2.5-.1.5-.5.9-1,.9Z",
                    fill: "#255dc4"
                  }),
                  /*#__PURE__*/_createVNode("path", {
                    d: "M24767.2,7291.3c.3,0,.6-.2.6-.5c0-.1-.1-.2-.1-.3v-.1-.1l-.4-.9-.4,1v.1c-.1.1-.1.2-.1.3-.2.2,0,.5.4.5m0,.7c-.7,0-1.4-.5-1.4-1.2c0-.2.1-.5.2-.7l1.1-2.6l1.1,2.6c.1.2.2.4.2.7.1.6-.5,1.2-1.2,1.2Z",
                    fill: "#255dc5"
                  })
                ])
              ]),
              /*#__PURE__*/_createVNode("g", { transform: "translate(40.3 45.703034)" }, [
                /*#__PURE__*/_createVNode("path", {
                  d: "M178.1,288.1l-9.5,8.3",
                  fill: "none",
                  stroke: "#9e2016",
                  "stroke-width": "4",
                  "stroke-linecap": "round",
                  "stroke-miterlimit": "10"
                }),
                /*#__PURE__*/_createVNode("path", {
                  d: "M168.6,287.9l9.2,8.5",
                  fill: "none",
                  stroke: "#9e2016",
                  "stroke-width": "4",
                  "stroke-linecap": "round",
                  "stroke-miterlimit": "10"
                }),
                /*#__PURE__*/_createVNode("path", {
                  d: "M173.4,305c7.9,0,14.4-5.8,14.4-12.9s-6.4-12.9-14.4-12.9-14.4,5.8-14.4,12.9s6.4,12.9,14.4,12.9Z",
                  fill: "none",
                  stroke: "#9e2016",
                  "stroke-width": "4",
                  "stroke-linecap": "round",
                  "stroke-miterlimit": "10"
                })
              ])
            ])
          ])
        ])
      ])
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($props.channelState === true)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _hoisted_2
      ]))
    : _createCommentVNode("", true)
}